var _style, _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNutrition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nutrition_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nutrition_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nutrition_svg__XMLID_983_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nutrition_svg__XMLID_990_",
    className: "nutrition_svg__st0",
    d: "M102.2 79.2c2.8-.4 5.7-.5 8.5-.3 6.6.6 11.7 6.2 11.5 12.8l-.4 21.5c-.1 4.2 3.3 7.6 7.5 7.5l12.1-.2.4-28.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nutrition_svg__XMLID_400_",
    className: "nutrition_svg__st0",
    d: "M87 110.2c-2.5 8.9-9.6 15.7-18.4 18.4-18.1 5.6-12.5 17.2-12.5 17.2s14.2-4.9 27.2-7c9.2-1.5 17.7-6.4 23.1-14.1.3-.5.7-1 1-1.5 3.3-5.1 8.7-8.4 14.5-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nutrition_svg__XMLID_399_",
    className: "nutrition_svg__st0",
    d: "M56.6 136.8L38.2 134 8.9 110.4s3.9-5.7 12.9-.4l19.9 13.2 15 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nutrition_svg__XMLID_397_",
    className: "nutrition_svg__st0",
    d: "M13.9 107.8L6 101.4s4.7-5.4 12.4-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nutrition_svg__XMLID_982_",
    className: "nutrition_svg__st0",
    d: "M59.3 109.7c.6.2 1.2.5 1.8.7 8.4 2.8 17.5.2 23.3-6.5 9-10.5 11.7-22.4 12.5-30.2.5-5.5 0-11.2-1.9-16.4-7.1-19.2-25.3-16.4-33.8-13.9-2.9.9-6 .9-8.9 0-8.5-2.5-26.7-5.3-33.8 13.9-2 5.2-2.5 10.9-2 16.5.8 7.8 3.5 19.7 12.6 30.2 5.8 6.7 15 9.2 23.3 6.4.6-.2 1.1-.4 1.7-.6 1.6-.8 3.5-.8 5.2-.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "nutrition_svg__XMLID_981_",
    className: "nutrition_svg__st0",
    d: "M60.2 32.3S62 9.5 86.6 10.4c0 0 2.1 8.8-4.4 16.4-2.9 3.4-7.8 6.6-15.2 8.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "nutrition_svg__XMLID_980_",
    className: "nutrition_svg__st0",
    d: "M55.1 38.1S55 25.4 40.3 20.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3 59.4c-3-8-8.3-11.8-16.7-11.8-3.8 0-7.4.8-9.8 1.5-2 .6-4.1.9-6.2.9-2.1 0-4.2-.3-6.2-.9-2.4-.7-6-1.5-9.8-1.5-4.1 0-7.5.9-10.2 2.8 1.2 1.6 2.5 3 4 4.3 5.3 4.6 12.4 7.1 19.4 6.9 5.3-.2 11-1.8 15.9.4 3.5 1.6 5.9 4.9 7.1 8.5 1.2 3.6 1.2 7.5.9 11.3-.7 8.1-3 16.1-6.7 23.4 3.4-.7 6.6-2.5 8.9-5.2 7.9-9.2 10.4-19.7 11-26.8.5-5 0-9.7-1.6-13.8z",
    fill: "var(--color-icon-secondary)"
  })));
}
export default SvgNutrition;